import type { FormikHandlers } from 'formik';

import { VStack, Box } from '@frontend/components';

import {
  AwsCredentialsInput,
  AwsCredentialsWarning,
} from 'components/IccConnection';

type IccSetupAwsCredentialsFieldsProps = {
  onChange: FormikHandlers['handleChange'];
};

/**
 * AWS credential inputs and warning for ICC setup (no outer indent wrapper).
 * Use beside `IccSetupReleaseChannel` inside a shared `VStack`.
 */
export const IccSetupAwsCredentialsFields = ({
  onChange,
}: IccSetupAwsCredentialsFieldsProps) => (
  <>
    <AwsCredentialsInput onChange={onChange} />
    <Box pt={1}>
      <AwsCredentialsWarning />
    </Box>
  </>
);

type IccSetupAwsCredentialsProps = {
  isOpen: boolean;
  onChange: FormikHandlers['handleChange'];
};

const IccSetupAwsCredentials = ({
  isOpen,
  onChange,
}: IccSetupAwsCredentialsProps) => {
  return isOpen ? (
    <VStack mt={-1} ml={3} align="stretch" spacing={2}>
      <IccSetupAwsCredentialsFields onChange={onChange} />
    </VStack>
  ) : null;
};

export default IccSetupAwsCredentials;
